import { DraggableImage } from 'components/DraggableImage';
import styles from '../../../CreateMemorialQuiltStepThree/styles.module.scss';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { DropZone } from 'components/DropZone';
import { useLocation } from 'react-router-dom';
import { useRef } from 'react';
import { useTranslates } from 'providers/translates';

type Props = {
  isAddImagesOnly: boolean | undefined;
  filesImages: File[];
  handleSetImage: (file: File) => void;
  deleteFileImage: (fileIndex: number) => Promise<void>;
  onSetShowClearImagesDialog: () => void;
  currentFileImage: File | null | undefined;
  imageRef: React.RefObject<HTMLImageElement>;
  isMain: boolean;
};

const EditorBlockMiddle: React.FC<Props> = ({
  isAddImagesOnly,
  filesImages,
  handleSetImage,
  deleteFileImage,
  onSetShowClearImagesDialog,
  currentFileImage,
  imageRef,
  isMain
}) => {
  const { translates } = useTranslates();
  const addAPhoto = translates?.quiltBuilderStepOne?.addAPhoto;
  const location = useLocation();
  const imageIndex = useRef<number | null>(null);

  const isAddImages = () => location.pathname.includes('add-images');

  return (
    <div className={styles.editorBlock1__middle}>
      <div
        className={styles.editorBlock1__middleLeft}
        style={{
          ...(isAddImagesOnly && {
            minWidth: '100%',
          }),
        }}
      >
        {filesImages &&
          filesImages.map((file, index) => {
            return (
              <div key={index} className={styles.imgWrapper}>
                <DraggableImage 
                  file={file}
                  index={index}
                  onSetImage={handleSetImage}
                  imageIndex={imageIndex}
                />
                {!isAddImages() && (
                  <div
                    className={styles.actionButtons}
                    onClick={() => deleteFileImage(index)}
                  >
                    <div className={styles.details__addPhotoActionSvg}>
                      <DeleteOutlineIcon />
                    </div>
                  </div>
                )}
              </div>
            );
          })
        }
      </div>
      {!isAddImagesOnly && (
        <>
          <div className={`${styles.editorBlock1__bottomButtonLeft} ${styles.isMobile}`}>
            <button
              className={`${styles.editorBlock1__button}`}
              style={{
                color: '#d85656',
              }}
              onClick={onSetShowClearImagesDialog}
            >
              {addAPhoto?.clearAlbumButtonText ?? 'clear album'}
            </button>
          </div>
          <DropZone
            image={currentFileImage}
            imageRef={imageRef}
            filesImages={filesImages}
            imageIndex={imageIndex}
            onSetImage={handleSetImage}
            isMain={isMain}
          />
        </>
      )}
    </div>
  );
}

export { EditorBlockMiddle };
